import { useEffect, useState } from 'react';
import { ShortcutEditor } from './ShortcutEditor';

/**
 * Host wrapper for the Keyboard Shortcuts editor.
 *
 * Owns the open/closed state locally so that opening the panel only
 * re-renders this subtree instead of the whole App tree (which would force
 * the 3D viewports to reconcile on every toggle).
 */
export function ShortcutEditorHost() {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        const handleOpen = () => setIsOpen(true);
        window.addEventListener('open-shortcut-editor', handleOpen);
        return () => window.removeEventListener('open-shortcut-editor', handleOpen);
    }, []);

    return <ShortcutEditor isOpen={isOpen} onClose={() => setIsOpen(false)} />;
}
